// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"8c05abed","454":"d30fa11a","943":"55dec4f4"}[chunkId] + ".chunk.css";
};